import "date-fns";
import "date-fns-tz";
import { s as m, u as f } from "./PreferenceService-67462235.mjs";
const g = function(e, r) {
  let n = {};
  if (e)
    if (e.PageConfigService)
      ({ PageConfigService: n } = e);
    else
      return e.PageConfigService = n, r(n);
  return n;
}(
  typeof window == "object" && window || typeof globalThis == "object" && globalThis || void 0,
  function(e) {
    let r = {};
    const n = () => r, c = (o) => {
      r = Object.assign(r, o);
    };
    return e.getPageConfigs = n, e.setPageConfigs = c, e;
  }
);
var l = /* @__PURE__ */ ((e) => (e.CURRENCY = "currency", e.DECIMAL = "decimal", e))(l || {}), s = /* @__PURE__ */ ((e) => (e.BEFORE_PRICE = "before_price", e.AFTER_PRICE = "after_price", e))(s || {}), u = /* @__PURE__ */ ((e) => (e.SYMBOL = "symbol", e.CODE = "code", e))(u || {});
m.getPreferences();
const O = (e) => {
  const { locale: r } = m.getPreferences();
  let n = new Intl.NumberFormat(r || "th", {
    style: l.DECIMAL
  }).format(e);
  return n = n.replace(/[\u00a0]/g, " "), n;
}, R = (e, r = null) => {
  const { locale: n, currency: c, currencyFormatConfig: o } = m.getPreferences(), i = r || c;
  let t = "";
  return o && i in o ? t = d(e, o[i]) : (t = new Intl.NumberFormat(n || "th", {
    style: i ? l.CURRENCY : l.DECIMAL,
    ...i && { currency: i }
  }).format(e), t = t.replace(/ /g, " "), t.match(/^(\D)(\d)/gm) && (t = t.replace(t[0], `${t[0]} `))), t;
}, a = (e, r) => Number(e) >= 1e3 ? e.indexOf(".") > -1 ? `${a(e.slice(0, e.indexOf(".") - 3), r)}${r ?? ","}${e.slice(e.indexOf(".") - 3)}` : `${a(e.slice(0, -3), r)}${r ?? ","}${e.slice(-3)}` : e, C = (e, r) => r === "CEIL" ? `${Math.ceil(Number(e))}` : r === "FLOOR" ? `${Math.floor(Number(e))}` : r === "ROUND" ? `${Math.round(Number(e))}` : e, d = (e, r) => {
  const n = f.getConfigs(), c = g.getPageConfigs();
  let o = e.toString();
  c != null && c.priceFormat && (o = C(o, c == null ? void 0 : c.priceFormat)), o = Number(o).toFixed(
    n.REMOVE_PRICE_TRAILING_ZEROS && Number.isInteger(Number(o)) ? 0 : r.decimals
  ), r != null && r.roundOff && (o = `${Math.round(Number(o))}.00`), o = a(o, r.thousandSeparator);
  const i = [...o], t = i.lastIndexOf(".");
  return t !== -1 && i.splice(t, 1, r.decimalSeparator), o = i.join(""), r.showSymbolOrCode === u.SYMBOL ? o = r.symbolPosition === s.BEFORE_PRICE ? `${r.symbol} ${o}` : `${o} ${r.symbol}` : o = r.codePosition === s.BEFORE_PRICE ? `${r.code} ${o}` : `${o} ${r.code}`, o;
};
export {
  R as X,
  O as z
};
//# sourceMappingURL=I18nUtils-f896b26a.mjs.map
